export {default as UserAvatar} from './Avatar.vue'
export {default as UserHoverCard} from './UserHoverCard.vue'
import {type VariantProps, cva} from 'class-variance-authority'
export {default as UserFollowButton} from './FollowButton.vue'

export const followButtonVariants = cva(
    'relative z-20',
    {
        variants: {
            variant: {
                default: '',
                outline: 'bg-transparent text-white border-white px-2 h-8'
            }
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)

export type FollowButtonVariants = VariantProps<typeof followButtonVariants>